
import { Pubsub } from '../libs/pubsub';

Pubsub.create = function(config = {}){
};

export {
    Pubsub
};
